import React, { useState, useRef, useEffect } from "react";
import {
  Container,
  Paper,
  Typography,
  Button,
  TextField,
} from "@material-ui/core";
import { useHistory, useLocation } from "react-router-dom";
import ContentWrapper from "../../../common/components/contentWrapper";
import "../../pages/dashboard/style/style.css";
import "../../../common/style/main.css";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import { MfaOverallSetting } from "../reducer/actions";

const MfaVerifyOtp = () => {
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const method = location?.state?.method || "email";
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [error, setError] = useState("");
  const [timer, setTimer] = useState(120);
  const [canResend, setCanResend] = useState(false);
  const inputRefs = useRef([]);

  useEffect(() => {
    inputRefs.current[0]?.focus();
  }, []);

  useEffect(() => {
    if (timer <= 0) {
      setCanResend(true);
      return;
    }

    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };

  const handleChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);
    setError("");

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handlePaste = (e, index) => {
    e.preventDefault();

    const pastedData = e.clipboardData.getData("text").replace(/\D/g, "");

    if (!pastedData) return;

    const updatedOtp = [...otp];

    pastedData.split("").forEach((char, i) => {
      const pasteIndex = index + i;

      if (pasteIndex < 6) {
        updatedOtp[pasteIndex] = char;
      }
    });

    setOtp(updatedOtp);

    const focusIndex = Math.min(index + pastedData.length, 5);

    setTimeout(() => {
      inputRefs.current[focusIndex]?.focus();
    }, 0);
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleVerify = () => {
    const otpValue = otp.join("");

    if (otpValue.length !== 6) {
      setError("Please enter all 6 digits");
      return;
    }

    setLoading(true);

    const payload = {
      otp: otpValue,
      email: mfaChannel === "email" ? email : null,
      phone: mfaChannel === "phone" ? `${countryCode}${phone}` : null,
      userId: userid,
      userid: userid,
      verify_otp: true,
      mfa_channel: mfaChannel,
      is_mfa_enabled: true,
    };

    MfaOverallSetting(payload, (err, res) => {
      setLoading(false);

      if (err || res?.status !== 1) {
        setError("Invalid or expired code. Please try again.");
        setOtp(["", "", "", "", "", ""]);
        inputRefs.current[0]?.focus();
        return;
      }
      
      if(!sessionStorage.getItem("token") && sessionStorage.getItem("temp_token")){
        sessionStorage.setItem("token", sessionStorage.getItem("temp_token"));
        sessionStorage.removeItem("temp_token");
      }

      toast("User logged successfully", {
        autoClose: 3000,
        type: toast.TYPE.SUCCESS,
        position: toast.POSITION.BOTTOM_CENTER,
      });
      setTimeout(() => {
        history.push("/search");
      }, 1000);
    });
  };

  const handleResend = () => {
    setTimer(120);
    setCanResend(false);

    const payload = {
      userid: userid,
      accountid: sessionStorage.getItem("accountId"),
      is_mfa_enabled: true,
      is_remindme_later: false,
      userId: userid,
      type: "otp",
      email: mfaChannel === "email" ? email : null,
      phone: mfaChannel === "phone" ? `${countryCode}${phone}` : null,
      mfa_channel: mfaChannel,
    };

    MfaOverallSetting(payload, (err, res) => {
      if (err || res?.status !== 1) {
        toast.error("MFA setup failed");
        return;
      }
      const successMessage =
        mfaChannel === "email"
          ? "Verification code sent to your email."
          : "Verification code sent to your phone.";

      toast.success(successMessage);
    });
  };
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails") || "{}");
  const mfaData = JSON.parse(sessionStorage.getItem("mfaData") || "{}");
  const userid =
    mfaData?.userId || userDetails?.userId || userDetails?.user?.userid;

  const email =
    mfaData?.email || userDetails?.email || userDetails?.user?.email || "";

  const phone =
    mfaData?.phone ||
    userDetails?.phone ||
    userDetails?.phonenumber ||
    userDetails?.user?.phone ||
    "";

  const countryCode =
    mfaData?.countryCode ||
    userDetails?.countryCode ||
    userDetails?.user?.countryCode ||
    "";

  const mfaChannel = mfaData?.mfa_channel || mfaData?.channel || method;

  const displayContact =
    mfaChannel === "email" ? email : `${countryCode} ${phone}`;
  const handleBack = () => {
    history.push("/mfa-verification");
  };

  const contentView = (
    <div>
      <Container
        style={{
          minHeight: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper
          className="border-radius"
          style={{
            width: "100%",
            maxWidth: "550px",
            borderRadius: "10px",
          }}
        >
          <div style={{ background: "#383838", padding: "10px" }}>
            <Typography variant="h5" align="center" className="text-white">
              Enter Verification Code
            </Typography>
          </div>

          <p
            style={{ textAlign: "center", color: "#555", padding: "10px 20px" }}
          >
            We sent a 6-digit verification code to
          </p>

          <p style={{ textAlign: "center", fontWeight: "600" }}>
            {displayContact}
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "10px",
              marginTop: "20px",
            }}
          >
            {otp.map((digit, index) => (
              <TextField
                key={index}
                inputRef={(el) => (inputRefs.current[index] = el)}
                value={digit}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                onPaste={(e) => handlePaste(e, index)}
                inputProps={{
                  maxLength: 1,
                  style: { textAlign: "center", fontSize: "18px" },
                }}
                style={{ width: "45px" }}
              />
            ))}
          </div>

          {error && (
            <p
              style={{
                marginTop: "10px",
                color: "red",
                fontSize: "13px",
                fontWeight: "500",
              }}
              align="center"
            >
              {error}
            </p>
          )}

          <Button
            variant="contained"
            onClick={(e) => {
              if (loading) {
                e.preventDefault();
                e.stopPropagation();
                return;
              }
              handleVerify();
            }}
            style={{
              marginTop: "20px",
              backgroundColor: "#CAAB74",
              color: "#fff",
              height: "45px",
              fontWeight: "600",
              width: "93%",
              marginLeft: "3%",
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.5 : 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            VERIFY
            {loading && (
              <CircularProgress size={20} style={{ color: "#fff" }} />
            )}
          </Button>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "15px",
              marginTop: "15px",
            }}
          >
            {canResend ? (
              <div className="text-center1">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleResend();
                  }}
                  style={{ color: "#CEA05F", fontWeight: "bold" }}
                >
                  Resend OTP
                </a>
              </div>
            ) : (
              <div className="text-center1">
                Didn't receive the code? Request New Code in{" "}
                <span style={{ fontWeight: "600" }}>{formatTime(timer)}</span>
              </div>
            )}

            {/* <Button
                onClick={handleBack}
                style={{
                  background: "#fff",
                  color: "#000",
                  border: "1px solid #ccc",
                  padding: "6px 16px",
                  textTransform: "uppercase",
                  width: "240px",
                }}
              >
                Back
              </Button> */}
          </div>
          <br />
        </Paper>
      </Container>
    </div>
  );

  return <ContentWrapper contentView={contentView} />;
};

export default MfaVerifyOtp;
